module.exports = __webpack_public_path__ + "static/img/DeluxeDoubleRoom1.e78095e2.jpg";